<template>
  <v-app  v-bind:style="stylePagina">
    <v-main  v-bind:style="stylePagina">

      <v-container fluid class="pt-6">
          <section>
            <v-row justify="center" align="center">
              <v-col cols="3">
                <h1 >Crea tu Espacio</h1>
              </v-col>
            </v-row>
          </section>
        <section >
      <v-row>
        <v-col cols="3">
          <v-autocomplete v-model="categoria" label="Escoge Categoria" :items="categorias" item-text="nombre" item-value="codigo" @change="escogecat">

          </v-autocomplete>
        </v-col>
        <v-col cols="3">
          <v-autocomplete v-model="ambiente" return-object label="Escoge Ambiente" :items="ambientesfiltr" item-text="nombre"  @change="escogeamb">

          </v-autocomplete>
        </v-col>
      </v-row>
          <v-row  justify="center" align="center">

            <v-col  cols="12" sm="12" md="6" lg="8" >
              <div  class="background-image-container" @click="handleBackgroundClick">

              <img ref="baseImage" width="100%" :src="backgroundImageUrl" />
     <overlay-image
         v-for="(overlay, index) in overlays"
         :key="index"
         :overlay="overlay"
         :overlay-index="index"
         :background-image-size="backgroundImageSize"
         @overlay-moved="handleOverlayMoved"
         @overlay-contextmenu="handleOverlayContextMenu"
     />
              </div>
            </v-col>
            <v-col  cols="12" sm="12" md="6" lg="3" >
              <v-row>
                <v-col>
                  <h2>Nombre:</h2>
                </v-col>

                <v-col>
                  {{producto.name}}
                </v-col>

              </v-row>
              <v-row>
                <v-col>
                  <h2>Modelo:</h2>
                </v-col>

                <v-col>
                  {{producto.modelo}}
                </v-col>

              </v-row>
              <v-row>
                <v-col>
                  <h2>Precio</h2>
                </v-col>
                <v-col>
                <span style="text-decoration:line-through;"> {{producto.precio}}</span> {{producto.preciodscto}}
                </v-col>

              </v-row>
              <v-row>
                <v-col>
                  <h2> Descripción</h2>
                </v-col>

              </v-row>
              <v-row>
                <v-col>
                  {{producto.descripcion}}
                </v-col>

              </v-row>


            </v-col>
          </v-row>
          <v-row justify="center" align="center">
            <v-col><h2>Instrucciones</h2>
            <ul>
              <li>
                Escoge dando click el producto para que aparezca en la galeria de productos de abajo.
              </li>
              <li>
                Una vez situada la imagen en el ambiente, dale click para comenzar a moverlo y otro click para situarla donde quieres.
              </li>
              <li>
                Si deseas borrar el producto solo dale click derecho.
              </li>
            </ul>
            </v-col>
          </v-row>
<v-row>
  <v-col>
    <carousel-3d :controls-visible="true" :clickable="false" :height="360">
          <slide
              v-for="(prod, index) in productosfilt"
              :key="index"
              :index="index"

          >
            <template slot-scope="{ index, isCurrent, leftIndex, rightIndex }">
              <h3 style="text-align: center;">{{prod.modelo}}</h3>
              <img :data-index="index" :class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0) }" :src="prod.image"  @click="cambiaprod(prod)">
            </template>
          </slide>
    </carousel-3d>
  </v-col>
</v-row>
        </section>

      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import OverlayImage from "@/components/componente/OverlayImage.vue";
import { Carousel3d, Slide } from 'vue-carousel-3d';
import lgproductos from "@/assets/json/lgproductos.json";

// optional style for arrows & dots
export default {
  name: "lgexperiencia",
  components: {OverlayImage, Carousel3d,
    Slide},
  title: "LG",
  data () {
    return {
      selectedOverlayIndex: null,
      currentIndex: 0,
      itemsToShow: 4,
      categoria:"sala",
      backgroundImageSize: { width: 0, height: 0 },
      producto:{
        name:'',
        image:'',
        width:'',
        modelo:'',
        descripcion:'',
        precio:''
      },

      categorias:[{nombre:"Sala",codigo:"sala"},{nombre:"Cocina",codigo:"cocina"},{nombre:"Dormitorio",codigo:"cuarto"}],
      backgroundImageUrl:'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/ambiente1.jpg',
      ambientesfiltr:[],
      productosfilt:[],
      ambiente:{nombre:"sala1",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala1.png",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala1v.png",categoria:"sala",ancho:"450",anchoMob:"250"},
      ambientes:[{nombre:"sala1",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala1.png",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala1v.png",categoria:"sala",ancho:"450",anchoMob:"250"},
        {nombre:"sala2",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala2.jpg",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala2v.png",categoria:"sala",ancho:"450",anchoMob:"250"},
        {nombre:"cocina1",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cocina1.png",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cocina1v.png",categoria:"cocina",ancho:"450",anchoMob:"250"},
        {nombre:"cocina2",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cocina2.jpg",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cocina2v.png",categoria:"cocina",ancho:"450",anchoMob:"250"},
        {nombre:"cuarto1",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cuarto1.jpg",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cuarto1v.png",categoria:"cuarto",ancho:"450",anchoMob:"250"},
        {nombre:"cuarto2",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cuarto2.jpg",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cuarto2v.png",categoria:"cuarto",ancho:"450",anchoMob:"250"}],
      alertnuevo: false,
      overlays:[],
      tagevento:'',
      productos:[],
      stylePagina: {
        fontColor:'black',
        fontFamily: 'LGSmartUI',
        color: '#1E3D90',
        backgroundColor:'#FFFFFF'
      },
      styleComponent:{
        color:'#1E3D90',
        backgroundColor:'#FFFFFF'
      },
      styleCabecera:{
        color:'#1E3D90',
        backgroundColor:'#FFFFFF'
      },
      styleForm:{
        color:'#000000',
        marginTop:'0px !important',
        fontFamily: 'LGSmartUI'
      },
      btnPag: {
        backgroundColor: '#1E3D90',
        color:'white'
      },
    }
  },
  created () {
    this.$vuetify.theme.dark = false
  },

  watch: {
    date () {
      this.editedItem.fechaNacimiento = this.formatDatee(this.date)
    }
  },
  mounted () {
    this.tagevento =  'lgexperiencia';
    this.getImageSize();
    this.productos = lgproductos;
    this.escogecat();
    if(!this.$device.mobile){
     this.backgroundImageUrl = 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala1.png'
    }else{
      this.backgroundImageUrl = 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala1v.png'

    }
  },
  methods: {
    async loadImageFromS3(imageUrl) {
      try {
        const response = await axios.get(imageUrl+'?not-from-cache-please`', {
          headers: { "Cache-Control": "no-cache" },
          responseType: 'blob'
        });
        return response.data;
      } catch (error) {
        console.error('Error al cargar la imagen desde S3:', error);
        return null;
      }
    },
    handleOverlayContextMenu(index) {
      // Eliminar el elemento del array overlays en función del índice
      this.overlays.splice(index, 1);
    },
    calculateNewHeight(originalWidth, originalHeight, newWidth) {
      // Asegurarse de que los valores sean números válidos
      const originalWidth2 = parseFloat(originalWidth) || 1;
      const  originalHeight2 = parseFloat(originalHeight) || 1;
      const   newWidth2 = parseFloat(newWidth) || 1;

      // Calcular el nuevo alto manteniendo las mismas proporciones (aspect ratio)
      const newHeight = (newWidth2 / originalWidth2) * originalHeight2;
      return newHeight;
    },
    async saveImage() {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = this.$refs.baseImage.width;
      canvas.height = this.$refs.baseImage.height;
      try {


      const imageBlob = await this.loadImageFromS3(this.$refs.baseImage.src);

      if(imageBlob){
            // Configura el tamaño del canvas según el tamaño de las imágenes
        const img = new Image();
        img.src = URL.createObjectURL(imageBlob);

        await new Promise((resolve) => {
          img.onload = resolve;
        });

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);


        await Promise.all(
            this.overlays.map(async (overlayImageUrl) => {
              const overlayImageBlob = await this.loadImageFromS3(overlayImageUrl.imageUrl);

              if (overlayImageBlob) {
                const imgR = new Image();
                imgR.src = URL.createObjectURL(overlayImageBlob);

                await new Promise((resolve) => {
                  imgR.onload = resolve;
                });
                  console.log(imgR)
                console.log('X:'+ overlayImageUrl.position.x)
                console.log('Y:'+ overlayImageUrl.position.y)
                console.log('width:'+ imgR.width)
                console.log('height:'+ imgR.height)
                  const newwidth = overlayImageUrl.width.slice(0, -2);
                console.log('height:'+ this.calculateNewHeight(overlayImageBlob.width, overlayImageBlob.height, newwidth))

                ctx.drawImage(
                    imgR,
                    overlayImageUrl.position.x,
                    overlayImageUrl.position.y,
                    newwidth,
                    this.calculateNewHeight(imgR.width, imgR.height, newwidth)
                );
              }
            })
        );

      // Obtén la imagen combinada como una URL de datos
      const combinedImageUrl = canvas.toDataURL('image/png');

      // Crea un enlace para descargar la imagen
      const link = document.createElement('a');
      link.href = combinedImageUrl;
      link.download = 'imagen_combinada.png';

      // Simula un clic en el enlace para iniciar la descarga
      link.click();

      }
      } catch (error) {
        console.error('Error al procesar la imagen:', error);
      }

    },
    cambiaprod(item){
      let ancho = 0;
      if(this.$device.mobile){
        ancho = this.ambiente.anchoMob
      }else{
        ancho = this.ambiente.ancho
      }
      const imagen = this.$refs.baseImage;

      // Capturamos el ancho de la imagen una vez que se ha cargado
      const anchoimg = imagen.offsetWidth;
      console.log(anchoimg)
      let newWidth = Number(item.width) * anchoimg / Number(ancho)
      let obj = {
        imageUrl: item.image,
        width: newWidth+"px",
        position: { x: 100, y: 100 }
      }
      const doesExist = this.overlays.some(obj => obj.imageUrl === item.image);
      if (!doesExist) {
        this.overlays.push(obj)
      }
      this.producto = item
    },
    escogecat(){
      this.ambientesfiltr = this.ambientes.filter(item=> item.categoria === this.categoria)
      this.productosfilt =  this.productos.filter(item=> item.categoria === this.categoria)
    },
    escogeamb(){
      if(this.$device.mobile){
        this.backgroundImageUrl = this.ambiente.urlMob

      }else{
        this.backgroundImageUrl = this.ambiente.url

      }
    },
    getImageSize() {
      const img = new Image();
      img.src = this.backgroundImageUrl;
      img.onload = () => {
        this.backgroundImageSize = {
          width: img.width,
          height: img.height
        };
      };
    },
    handleBackgroundClick() {
      if (this.selectedOverlayIndex !== null) {
        // Clear selection when clicking on the background
        this.selectedOverlayIndex = null;
      }    },
    handleOverlayMoved(overlayIndex, newPosition) {
      // Update the position of the overlay in the overlays array

        console.log('llega el movimiento')
        this.overlays[overlayIndex].position = newPosition;

    }

  },
  computed: {
    carouselStyles() {
      const translateX = -this.currentIndex * (100 / this.itemsToShow);
      return `transform: translateX(${translateX}%)`;
    },
  }
}
</script>

<style >
.grecaptcha-badge{
  display: none;
}
.background-image-container {
  position: relative;
}

.carousel-3d-slide img{
  width: auto !important;
  height: 100% !important;
}


.carousel-3d-slide{
  border: none !important;
  background-color: #FFFFFF !important;
}
</style>